<template>
  <div>
    <v-progress-linear indeterminate color="purple" class="mb-2" v-if="cargando" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-tabla-gestiones"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { cellRendererEliminadoEn, cellRendererNumeroRegistro } from '../utils';
import ListadoAgGridMixin from './../mixins/listado-ag-grid-mixin';

export default {
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'GESTIÓN',
          field: 'numero',
          filter: false,
          minWidth: 150,
        },
        {
          headerName: 'PRESUPUESTOS REGISTRADOS',
          filter: false,
          cellRenderer: (param) => {
            return param.data.presupuestos?.length > 0 ? 'Si' : /*html */ `<span style='color:#ea5455;'>No</span>`;
          },
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'CREADO EN',
          field: 'creado_en',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizado_en',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'ESTADO',
          filter: false,
          cellRenderer: cellRendererEliminadoEn,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
    };
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-tabla-gestiones {
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
</style>
  